import comp from "./LTIComponent";
export default comp;
